export default "__VITE_ASSET__pz_WQk7i__"